export default __webpack_public_path__ + "static/hc-header-banner-716f24c51b6de2aa61563abd76773db6.png";